import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {redirecionarParaLoginExterno} from '@bndes/bndes-ux4/bn-seguranca';

@Component({
  selector: 'login-via-prc',
  template: '',
  standalone: false
})
export class LoginViaPRCComponent implements OnInit {

  constructor(private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    const returnUrlParam = this.route.snapshot.queryParams['returnUrl'];
    const returnRoute = returnUrlParam ? `/#${returnUrlParam}` : '';
    const returnUrl = this.prefixoApp + returnRoute;
    redirecionarParaLoginExterno(returnUrl);
  }

  get prefixoApp(): string {
    const url = new URL(window.location.href);
    const isLocalhost = url.hostname.indexOf('localhost') > -1;
    return isLocalhost ? url.origin : `${url.origin}/${url.pathname.split('/')[1]}`;
  }

}
